import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeatureGrid from './components/FeatureGrid';
import ArticleGrid from './components/ArticleGrid';
import CTASection from './components/CTASection';
import { articles } from '@/mocks/articles';

export default function Home() {
  const schemaData = {
    '@context': 'https://schema.org',
    '@type': 'Blog',
    name: '吃瓜每日榜单',
    description: '网罗全网最新最热的娱乐八卦、社会热点、网络爆料。每日更新热榜排名，新鲜大瓜不容错过！',
    url: 'http://yyweilai.com/',
    blogPost: articles.map((article) => ({
      '@type': 'BlogPosting',
      headline: article.title,
      description: article.excerpt,
      image: article.coverImage,
      datePublished: article.publishedAt,
      author: {
        '@type': 'Person',
        name: article.author.name,
      },
      url: `http://yyweilai.com/article/${article.slug}`,
    })),
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeatureGrid />
        <ArticleGrid />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}
